import CatchUpDiscussionType from "../types/catch-ups/CatchUpDiscussionType";

export function resolveCatchUpDiscussionType(
  subjectClientFormId: number | undefined,
  genericCatchUpFormId: number | null | undefined,
  isFreeTypedSubject: boolean,
): CatchUpDiscussionType {
  if (
    isFreeTypedSubject ||
    (genericCatchUpFormId != null &&
      subjectClientFormId === genericCatchUpFormId)
  ) {
    return "GENERAL-CATCH-UP";
  }
  return "REVIEW";
}
